import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import {
  FaDesktop,
  FaWifi,
  FaPowerOff,
  FaBatteryHalf,
  FaExclamationTriangle,
} from "react-icons/fa";
import AnimatedNumber from "./AnimatedNumber";
import dev from "../models/joinDevice.json";
import "./HomeKpiTiles.css";

const tileVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.06, type: "spring", stiffness: 240, damping: 22 },
  }),
};

const Tile = ({ icon, label, value, suffix, tone, index }) => (
  <motion.div
    className={`kpi-tile kpi-tile--${tone}`}
    custom={index}
    variants={tileVariants}
    initial="hidden"
    animate="visible"
    whileHover={{ y: -3 }}
  >
    <span className="kpi-tile__icon">{icon}</span>
    <span className="kpi-tile__body">
      <span className="kpi-tile__value">
        <AnimatedNumber value={value} />
        {suffix}
      </span>
      <span className="kpi-tile__label">{label}</span>
    </span>
  </motion.div>
);

const HomeKpiTiles = ({ devices = [] }) => {
  const [t] = useTranslation();

  const online = devices.filter((d) => d.state === dev.typestates.on).length;
  const offline = devices.length - online;
  const batteries = devices
    .map((d) => parseInt(d.battery))
    .filter((v) => !isNaN(v));
  const avgBattery = batteries.length
    ? Math.round(batteries.reduce((a, b) => a + b, 0) / batteries.length)
    : 0;
  const critical = devices.filter(
    (d) =>
      d.state !== dev.typestates.on ||
      (!isNaN(parseInt(d.battery)) && parseInt(d.battery) <= 25)
  ).length;

  const tiles = [
    {
      icon: <FaDesktop />,
      label: t("device-stats.total"),
      value: devices.length,
      tone: "primary",
    },
    {
      icon: <FaWifi />,
      label: t("device-stats.online"),
      value: online,
      tone: "success",
    },
    {
      icon: <FaPowerOff />,
      label: t("device-stats.offline"),
      value: offline,
      tone: "danger",
    },
    {
      icon: <FaBatteryHalf />,
      label: t("home.avg-battery"),
      value: avgBattery,
      suffix: "%",
      tone: "warning",
    },
    {
      icon: <FaExclamationTriangle />,
      label: t("home.critical"),
      value: critical,
      tone: "danger",
    },
  ];

  return (
    <div className="kpi-tiles">
      {tiles.map((tile, i) => (
        <Tile key={tile.label} index={i} {...tile} />
      ))}
    </div>
  );
};

export default HomeKpiTiles;
